const API_URL = process.env.REACT_APP_API_URL;

const SubmitGame = async (dataToSend) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        });

        if (response.status === 409) {
            return { success: false, status: 409, message: 'Duplicate entry' };
        }

        if (!response.ok) {
            return { success: false, status: response.status, message: 'Server error' };
        }

        const data = await response.json();
        return { success: true, data: data };

    } catch (error) {
        return { success: false, status: 0, message: 'Network error' };
    }
};

const ValidatePlayer = async (email, phone) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/check`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, phoneNumber: phone })
        });

        if (response.status === 409) {
            return { success: false, status: 409, message: 'Ya jugado' };
        }
        
        if (!response.ok) {
            return { success: false, status: response.status, message: 'Error server' };
        }

        return { success: true };
    } catch (error) {
        return { success: false, status: 0, message: 'Error red' };
    }
};

const ShowOverlay = async () => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/overlay/show`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const HideOverlay = async () => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/overlay/hide`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const RefreshOverlay = async () => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/overlay/refresh`, { method: 'POST' });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ConfigOverlay = async (data) => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/overlay/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ConfigGame = async (data) => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/config-game`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

const ResetGame = async () => {
    try {
        await fetch(`${API_URL}PluckingTheRooster/reset`, { method: 'POST' }); 
        return { success: true };
    } catch { return { success: false, message: 'Error de red' }; }
};

// =================================================================================================
// NUEVOS MÉTODOS ESTILO BARRIO 9 (OVERLAY QUIZZ)
// =================================================================================================

const GetSettings = async () => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/settings`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener settings.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const GetAdminParticipants = async () => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/participants`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener participantes.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const SelectWinner = async (id) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/participants/${id}/select-winner`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al seleccionar ganador.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdatePosition = async (offset) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/position?offset=${offset}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar la posición.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdateBannerMode = async (mode) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/banner-mode?mode=${mode}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar el modo del banner.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdateOverlayVisibility = async (visible) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/overlay-visibility?visible=${visible}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar la visibilidad del overlay.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const TrackMetric = async (eventName, sessionId, source) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ eventName, sessionId, source })
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al guardar métrica.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const GetAdminStats = async () => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/stats`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener estadísticas.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const ToggleActiveGame = async (active) => {
    try {
        const response = await fetch(`${API_URL}PluckingTheRooster/admin/toggle-active?active=${active}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar estado.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

export {
    SubmitGame,
    ValidatePlayer,
    ShowOverlay,
    HideOverlay,
    RefreshOverlay,
    ConfigOverlay,
    ConfigGame,
    ResetGame,
    GetSettings,
    GetAdminParticipants,
    SelectWinner,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    TrackMetric,
    GetAdminStats,
    ToggleActiveGame
};